var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3667 4.76665H4.63333C4.00741 4.76665 3.5 5.27407 3.5 5.89999V18.3667C3.5 18.9926 4.00741 19.5 4.63333 19.5H19.3667C19.9926 19.5 20.5 18.9926 20.5 18.3667V5.89999C20.5 5.27407 19.9926 4.76665 19.3667 4.76665Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.29996H20.5",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0332 6.46667V2.5",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9668 6.46667V2.5",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18372 12.1333C7.12769 12.1333 7.07291 12.1499 7.02631 12.1811C6.97972 12.2122 6.9434 12.2564 6.92196 12.3082C6.90051 12.36 6.8949 12.4169 6.90583 12.4719C6.91677 12.5269 6.94375 12.5774 6.98338 12.617C7.023 12.6566 7.07349 12.6836 7.12845 12.6945C7.18341 12.7055 7.24038 12.6998 7.29215 12.6784C7.34392 12.657 7.38817 12.6206 7.41931 12.574C7.45044 12.5275 7.46706 12.4727 7.46706 12.4166C7.46706 12.3415 7.43721 12.2694 7.38407 12.2163C7.33094 12.1632 7.25887 12.1333 7.18372 12.1333Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18372 16.1C7.12769 16.1 7.07291 16.1166 7.02631 16.1477C6.97972 16.1789 6.9434 16.2231 6.92196 16.2749C6.90051 16.3267 6.8949 16.3836 6.90583 16.4386C6.91677 16.4936 6.94375 16.544 6.98338 16.5837C7.023 16.6233 7.07349 16.6503 7.12845 16.6612C7.18341 16.6721 7.24038 16.6665 7.29215 16.6451C7.34392 16.6236 7.38817 16.5873 7.41931 16.5407C7.45044 16.4941 7.46706 16.4394 7.46706 16.3833C7.46706 16.3082 7.43721 16.2361 7.38407 16.183C7.33094 16.1298 7.25887 16.1 7.18372 16.1Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.1333C11.9441 12.1333 11.8893 12.1499 11.8427 12.1811C11.7961 12.2122 11.7598 12.2564 11.7384 12.3082C11.7169 12.36 11.7113 12.4169 11.7222 12.4719C11.7332 12.5269 11.7602 12.5774 11.7998 12.617C11.8394 12.6566 11.8899 12.6836 11.9449 12.6945C11.9998 12.7055 12.0568 12.6998 12.1086 12.6784C12.1603 12.657 12.2046 12.6206 12.2357 12.574C12.2668 12.5275 12.2835 12.4727 12.2835 12.4166C12.2835 12.3415 12.2536 12.2694 12.2005 12.2163C12.1473 12.1632 12.0753 12.1333 12.0001 12.1333Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.1C11.9441 16.1 11.8893 16.1166 11.8427 16.1477C11.7961 16.1789 11.7598 16.2231 11.7384 16.2749C11.7169 16.3267 11.7113 16.3836 11.7222 16.4386C11.7332 16.4936 11.7602 16.544 11.7998 16.5837C11.8394 16.6233 11.8899 16.6503 11.9449 16.6612C11.9998 16.6721 12.0568 16.6665 12.1086 16.6451C12.1603 16.6236 12.2046 16.5873 12.2357 16.5407C12.2668 16.4941 12.2835 16.4394 12.2835 16.3833C12.2835 16.3082 12.2536 16.2361 12.2005 16.183C12.1473 16.1298 12.0753 16.1 12.0001 16.1Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8165 12.1333C16.7605 12.1333 16.7057 12.1499 16.6591 12.1811C16.6125 12.2122 16.5762 12.2564 16.5548 12.3082C16.5333 12.36 16.5277 12.4169 16.5386 12.4719C16.5496 12.5269 16.5766 12.5774 16.6162 12.617C16.6558 12.6566 16.7063 12.6836 16.7613 12.6945C16.8162 12.7055 16.8732 12.6998 16.925 12.6784C16.9767 12.657 17.021 12.6206 17.0521 12.574C17.0833 12.5275 17.0999 12.4727 17.0999 12.4166C17.0999 12.3415 17.07 12.2694 17.0169 12.2163C16.9637 12.1632 16.8917 12.1333 16.8165 12.1333Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8165 16.1C16.7605 16.1 16.7057 16.1166 16.6591 16.1477C16.6125 16.1789 16.5762 16.2231 16.5548 16.2749C16.5333 16.3267 16.5277 16.3836 16.5386 16.4386C16.5496 16.4936 16.5766 16.544 16.6162 16.5837C16.6558 16.6233 16.7063 16.6503 16.7613 16.6612C16.8162 16.6721 16.8732 16.6665 16.925 16.6451C16.9767 16.6236 17.021 16.5873 17.0521 16.5407C17.0833 16.4941 17.0999 16.4394 17.0999 16.3833C17.0999 16.3082 17.07 16.2361 17.0169 16.183C16.9637 16.1298 16.8917 16.1 16.8165 16.1Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.be1d798dc94ac25a043102188443e9c2.svg";
export { ForwardRef as ReactComponent };